import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Form, Input, Tabs, message, Select, DatePicker, Button, Radio,Modal,Cascader,Checkbox ,Tooltip,Icon} from 'antd';
import axios from 'axios';
import API from '../../../../../API/api';
import moment from 'moment';
import TreeControl from './TreeControl'
import { ASSIST, KNOWLEDGEWITHISSUE,ALBUM,SUBJECT } from '../../../../../utils/questionManageType';
import $ from '$'

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const Option = Select.Option;

class CreateTask extends Component{
    state = {
        loading: false,
        tab:'1',
        start_time:'',
        end_time:'',
        section:false,
        assistList:[],
        knowledgeTreeList:[],
        knowledgeTreeListFetching:false,
        assistTreeList:[],
        assistTreeListFetching:false,

        skip_know:true,
        check_user:'',
        select_user:'',
        node_knowledge_type:[],
        is_spread:'1',
        tag_type:['-1'],
        tagTypeList:[],
    }
    onTabChange = (key) => {
        this.setState({tab:key})
    }

    handleAssistChange = (value) => {
        let rootId = value[value.length - 1];
        this.setState({assist:rootId,section:false})
        this.handleGetTreeList(rootId,ASSIST,'assistTreeList')
    }
    handleSkip = (val, type) => {
        this.setState({[type]:val.target.checked})
    }
    handleTreeSelect=(selectedKeys,type)=>{
        this.setState({section:selectedKeys[0]||false})
    }
    handleGetTreeList = (rootId, relate_type,list) => {
        this.setState({knowledgeTreeListFetching:true});
        axios.post(API.GET_TREE_LIST,{ type: relate_type, rootId }).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({[list]:res.data.list,knowledgeTreeListFetching:false});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    handleGetTreeListAlbum = () => {
        if(this.props.user.subject!==SUBJECT.ENGLISH){return}
        this.setState({albumTreeListFetching:true});
        axios.post(API.SELECT_ALBUM_LIST).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({albumList:res.data,albumTreeListFetching:false});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    onOk = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {


                let data = {};
                let relate_id;
                let relate_type;
                relate_id = this.state.section;
                if(this.state.tab == 1){
                    if(!this.state.section)
                    {
                        relate_type=11;
                        relate_id=this.state.assist;
                    }
                    else{
                        relate_type=1;
                    }
                }else if(this.state.tab == 26){
                    relate_type=26;
                }
                else if(this.state.tab == 3){
                    relate_type=3;
                }
                if(!relate_id){return message.error('请选择教辅或知识点')}
                if(!this.state.node_knowledge_type){return message.error('请选择题目类型')}

                let tag_type = [...this.state.tag_type]

                let node_knowledge_type = [...this.state.node_knowledge_type]
                if(node_knowledge_type.findIndex((d)=>d==='all')!==-1){
                    node_knowledge_type.splice(node_knowledge_type.findIndex((d)=>d==='all'),1)
                }
                if(node_knowledge_type.findIndex((d)=>d==='选中多个')!==-1){
                    node_knowledge_type.splice(node_knowledge_type.findIndex((d)=>d==='选中多个'),1)
                }
                node_knowledge_type = node_knowledge_type.map(d=>{//将字符串变为数字
                    return +d

                })
                let index = tag_type.findIndex(d=>d=='选中多个')//增加选中多个的效果
                if(index!==-1){
                    tag_type.splice(index,1)
                }


                data = {
                    name:values.name,
                    mark:values.mark||'',
                    task_id:this.props.taskId,
                    select_user:this.state.select_user,
                    check_user:this.state.check_user,
                    node_knowledge_type:node_knowledge_type,
                    is_spread:~~this.state.is_spread,
                    question_start_time:this.state.start_time,
                    question_end_time:this.state.end_time,
                    skip_know:~~this.state.skip_know,
                    relate_type,
                    relate_id,
                    tag_type
                }
                this.setState({ disabledOnOk: true});
                axios.post(API.QSELECTTNEW_TASK_ADD,data).then((res)=>{
                    res = res.data
                    if (res.code === 0) {
                        message.success('任务创建成功');
                        this.setState({ disabledOnOk: false, visible:false});
                        this.props.refresh();
                        this.props.onCancel();
                    }else{
                        message.error(res.message);
                        this.setState({ disabledOnOk: false});
                    }
                },(error)=>{
                    message.error('网络错误！');
                });
            }


        });
    }
    componentDidMount(){
        axios.post(API.GET_NO_SUBJECT_ASSIST_LIST).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({assistList:res.data.list});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
        axios.post(API.QSELECTTNEW_TASK_TAG_TYPE).then((res)=>{//标签种类的枚举
            res = res.data
            if (res.code === 0) {
                this.setState({tagTypeList:res.data});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
        this.handleGetTreeList(0,KNOWLEDGEWITHISSUE,'knowledgeTreeList')
        this.handleGetTreeListAlbum()
    }

    disabledStartDate = (startValue) => {
        const endValue = moment(this.state.end_time);
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    }

    disabledEndDate = (endValue) => {
        const startValue = moment(this.state.start_time);
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    }

    questionTypeChange = (value,list) => {
        let index = value.findIndex(d=>d=='选中多个')//增加选中多个的效果
        if(index!==-1){
            value.splice(index,1)
        }
        if(value.length<this.state.tag_type.length){//减少选中时
            if(value.length == list.length-1){//取消全部时
                let index = value.findIndex(d=>d=='-1')
                if(index==-1){
                    value = []
                }
            }
            let index = value.findIndex(d=>d=='-1')
            if(index!==-1){
                value.splice(index,1)
            }
        }else if(value.length==list.length-1){//选中了其余所有后自动选中全部
            value = list.map(d=>''+d.id)
        }
        if(value.findIndex(d=>d=='4')==-1){
            this.setState({skip_know: 0})
            this.setState({is_spread: '0'})
            let index = value.findIndex(d=>d=='5')
            if(index!==-1){
                value.splice(index,1)
            }
        }
        this.setState({tag_type: value});
        this.forceUpdate()
    }
    checkMultiple=(state,list)=>{
        if(!(list&&list.length)){return}
        let index = this.state.tag_type.findIndex(d=>d=='选中多个')//增加选中多个的效果
        if(index!==-1){
            this.state.tag_type.splice(index,1)
        }

        if(this.state.tag_type.some(d=>d=='5')){
            if(this.state.tag_type.length===list.length){return}
            if(!this.state.tag_type.some(d=>d=='4')){
                this.state.tag_type.push('4')
            }
        }
        if(this.state.tag_type.some(d=>d=='-1')){
                if(this.state.tag_type.length===list.length){return}
                let arr = list.map(d=>''+d.id)
                this.state.tag_type = arr
        }

        else if(this.state.tag_type.length>1){
            this.state.tag_type.unshift('选中多个')
        }
    }

    questionTypeChangeClassify = (value,list) => {
        let index = value.findIndex(d=>d=='选中多个')//增加选中多个的效果
        if(index!==-1){
            value.splice(index,1)
        }
        if(value.length<this.state.node_knowledge_type.length){//减少选中时
            if(value.length == list.length-1){//取消全部时
                let index = value.findIndex(d=>d=='all')
                if(index==-1){
                    value = []
                }
            }
            let index = value.findIndex(d=>d=='all')
            if(index!==-1){
                value.splice(index,1)
            }
        }else if(value.length==list.length-1){//选中了其余所有后自动选中全部
            value = list.map(d=>''+d.id)
        }
        this.setState({node_knowledge_type: value});
        this.forceUpdate()
    }
    checkMultipleClassify=(state,list)=>{
        if(!(list&&list.length)){return}
        let index = this.state.node_knowledge_type.findIndex(d=>d=='选中多个')//增加选中多个的效果
        if(index!==-1){
            this.state.node_knowledge_type.splice(index,1)
        }

        if(this.state.node_knowledge_type.some(d=>d=='all')){
            if(this.state.node_knowledge_type.length===list.length){return}
            let arr = list.map(d=>''+d.id)
            this.state.node_knowledge_type = arr
        }
        else if(this.state.node_knowledge_type.length>1){
            this.state.node_knowledge_type.unshift('选中多个')
        }
    }
    render(){
        let {visible } = this.props;
        let filterList  = [...this.props.filterList]
        if(filterList&&filterList.length){filterList.unshift({id:'all',name:'全部'})}
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        const loop = data => data.map(item => {
            let option = { value: item.assist_id || item.book_id || item.edition_id, label: item.name }
            if (item.list) option.children = loop(item.list)
            return option;
        })
        return(
                <Modal
                    visible={visible}
                    title={this.props.taskId?"修改任务":"新建任务"}
                    onCancel={this.props.onCancel}
                    footer={[
                        <Button key="back" size="large" onClick={this.props.onCancel}>取消</Button>,
                        <Button key="submit" type="primary" size="large" disabled={this.state.disabledOnOk} onClick={this.onOk}>
                            {this.props.taskId?"修改任务":"创建任务"}
                        </Button>,
                    ]}
                >
                    <Form>
                        <FormItem
                            {...formItemLayout}
                            label="任务名称"
                            hasFeedback
                            style={{marginBottom:10,marginRight:10,}}
                        >
                            {getFieldDecorator('name', {
                                initialValue:this.state.name,
                                rules: [{
                                    type: 'string', message: '请输入正确的任务名称',
                                }, {
                                    required: true, message: '请输入任务名称',
                                }],
                            })(
                                <Input onChange={(e)=>{ e.target.value = e.target.value.slice(0,20) }}/>
                            )}

                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="打标签"
                            hasFeedback
                            style={{marginBottom:10,marginRight:10,}}
                        >
                            {getFieldDecorator('select_user', {
                                initialValue:this.state.select_user,

                            })(
                                <Select
                                    style={{ width: 120 }}
                                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    // showSearch
                                    onChange={(val)=>{this.setState({select_user:val})}}
                                    showSearch
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}

                                >
                                    {
                                        this.props.selectList&&this.props.selectList.map(item =>
                                            <Option key={item.id} value={item.id.toString()}>{item.name}</Option>)
                                    }
                                </Select>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="审核"
                            hasFeedback
                            style={{marginBottom:10,marginRight:10,}}
                        >
                            {getFieldDecorator('check_user', {
                                initialValue:this.state.check_user,

                            })(
                                <Select
                                    style={{ width: 120 }}
                                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    // showSearch
                                    onChange={(val)=>{this.setState({check_user:val})}}
                                    showSearch
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}

                                >
                                    {
                                        this.props.checkList&&this.props.checkList.map(item =>
                                            <Option key={item.id} value={item.id.toString()}>{item.name}</Option>)
                                    }
                                </Select>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="标签种类"
                            hasFeedback
                            style={{marginBottom:10,marginRight:10,}}
                            className={'creat_task_multipe_select creat_task_multipe_select_tagType'}

                        >
                            {
                                (this.checkMultiple(this.state,this.state.tagTypeList)||1)&&
                                <Select value={ this.state.tag_type }
                                        style={{width:100, marginRight:20}}
                                        mode={"multiple"}
                                        onBlur={()=>{
                                            $('.creat_task_multipe_select_tagType .ant-select-selection--multiple').css('height','auto')
                                            setTimeout(()=>{
                                                $('.creat_task_multipe_select_tagType .ant-select-selection--multiple').css('height','28px')
                                            },0)}}
                                        onChange = { (value, option) => this.questionTypeChange(value, this.state.tagTypeList) }>
                                    {
                                        this.state.tagTypeList&&this.state.tagTypeList.map((v,k) =>
                                            <Option key = {k} value= {''+v.id}>{v.name}</Option>
                                        )
                                    }
                                </Select>
                            }
                        </FormItem>



                        <FormItem
                            {...formItemLayout}
                            label="类型"
                            hasFeedback
                            style={{marginBottom:20,marginRight:10,}}
                            className={'creat_task_multipe_select creat_task_multipe_select_classify'}

                        >
                            {
                                (this.checkMultipleClassify(this.state,filterList)||1)&&
                                <Select
                                    value={ this.state.node_knowledge_type }
                                    style={{ width: 120 }}
                                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    // showSearch
                                    mode={"multiple"}
                                    onBlur={()=>{
                                        $('.creat_task_multipe_select_classify .ant-select-selection--multiple').css('height','auto')
                                        setTimeout(()=>{
                                            $('.creat_task_multipe_select_classify .ant-select-selection--multiple').css('height','28px')
                                        },0)}}
                                    onChange={(value, option) => this.questionTypeChangeClassify(value, filterList)}
                                >
                                    {
                                        filterList&&filterList.map(item =>
                                            <Option key={item.id} value={item.id.toString()}>{item.name}</Option>)
                                    }
                                </Select>
                            }
                        </FormItem>

                        {
                            this.props.user.subject===SUBJECT.MATH&&
                            <FormItem
                                {...formItemLayout}
                                label="泛化"
                                hasFeedback
                                style={{marginBottom:10,marginRight:10,}}
                            >

                                <Radio.Group value={this.state.is_spread} onChange={(e)=>{this.setState({is_spread:e.target.value})}}>
                                    <Radio value="1">需要泛化</Radio>
                                    <Radio value="0">不需要</Radio>
                                </Radio.Group>

                                <Tooltip
                                    title={<div>
                                        <div>
                                            由于沪教版独有名词原因关闭沪教版与其他版本泛化：
                                        </div>
                                        <div>
                                            a)由沪教版录入的题目无论是勾选"需要泛化"或者"不需要"，都默认为不泛化；
                                        </div>
                                        <div>
                                            b)其他版本录入题目的泛化教材中不包括沪教版。
                                        </div>
                                    </div>

                                    }
                                    mouseEnterDelay={0.5}>
                                    <Icon type="question-circle-o" style={{marginLeft:20,color:'#1890ff',cursor: 'help'}} />
                                </Tooltip>
                            </FormItem>
                        }


                        <FormItem style={{marginBottom:10,marginRight:10,}} hasFeedback{...formItemLayout}
                                  label="题目上线时间">
                            {
                                getFieldDecorator('dateStart', {
                                    value:this.state.start_time !==''?moment(this.state.start_time, 'YYYY-MM-DD'):undefined,

                                })(<DatePicker
                                        format="YYYY-MM-DD"
                                        placeholder={'开始时间'}
                                        style={{marginRight:10,width:120}}
                                        disabledDate={this.disabledStartDate}
                                        onChange={(e,value)=>{this.setState({start_time:value})}}
                                    />
                                )

                            }
                            {
                                getFieldDecorator('dateEnd', {
                                    value:this.state.end_time !==''?moment(this.state.end_time, 'YYYY-MM-DD'):undefined,

                                })(<DatePicker
                                        format="YYYY-MM-DD"
                                        placeholder={'结束时间'}
                                        style={{width:120}}

                                        disabledDate={this.disabledEndDate}
                                        onChange={(e,value)=>{this.setState({end_time:value})}}
                                    />
                                )
                            }
                        </FormItem>
                        <FormItem style={{marginBottom:10,marginRight:10,}} hasFeedback{...formItemLayout}
                                  label="">
                            <Checkbox style={{marginLeft:20}} checked = { this.state.skip_know } onChange = { (val)=>{this.handleSkip(val,'skip_know')} }>跳过已有知识点/考点/选精的题目</Checkbox>

                        </FormItem>

                        <Tabs defaultActiveKey= { `1` } onChange={ this.onTabChange }>
                            <TabPane tab="章节" key = { `1` }>
                                <Cascader allowClear={ false }  popupPlacement="topLeft" style={ {width:"60%"} } options={ loop(this.state.assistList) ? loop(this.state.assistList) : [] } onChange={ this.handleAssistChange } placeholder="Please select" />
                                <TreeControl
                                    treeData={ this.state.assistTreeList }
                                    key = { ASSIST }
                                    loading= { this.state.assistTreeListFetching }
                                    handleTreeSelect = { selectedKeys => this.handleTreeSelect(selectedKeys, ASSIST) }
                                    checkable= { false }
                                    checkStrictly = { false }
                                />
                            </TabPane>
                            <TabPane tab="知识点及考点" key={ `${KNOWLEDGEWITHISSUE}` }>
                                <TreeControl
                                    treeData={ this.state.knowledgeTreeList }
                                    key = { KNOWLEDGEWITHISSUE }
                                    loading= { this.state.knowledgeTreeListFetching }
                                    handleTreeSelect = { selectedKeys => this.handleTreeSelect(selectedKeys, KNOWLEDGEWITHISSUE) }
                                    checkable= { false }
                                    checkStrictly = { false }
                                />
                            </TabPane>
                            {
                                this.props.user.subject===SUBJECT.ENGLISH&&
                                <TabPane tab="专辑" key={ `${ALBUM}` }>
                                    <TreeControl
                                        treeData={ this.state.albumList }
                                        key = { ALBUM }
                                        loading= { this.state.albumTreeListFetching }
                                        handleTreeSelect = { selectedKeys => this.handleTreeSelect(selectedKeys, ALBUM) }
                                        checkable= { false }
                                        checkStrictly = { false }
                                    />
                                </TabPane>
                            }

                        </Tabs>
                    </Form>
                </Modal>
        );
    }

}
const WrappedCreateTaskForm = Form.create()(CreateTask);
// export default WrappedCreateTaskForm

const mapStateTopProps = state => {
    console.log(state.questionManage.setTag.filterList)
    return {
        selectList: state.questionManage.setTag.selectList,
        checkList: state.questionManage.setTag.checkList,
        filterList: state.questionManage.setTag.filterList,
        user: state.user,
    }
}
const mapDispatchToProps = dispatch => {
    return {
    }
};
export default connect(mapStateTopProps, mapDispatchToProps)(WrappedCreateTaskForm);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/set_tag/tag_task_list/creat_task/view.js